import React from "react";
import Modal from "react-modal";
import { FiX } from "react-icons/fi";
import "./CreateCustomProjectModal.css";

Modal.setAppElement("#root");

function UserInputModal({
  newProjectInputModalOpen,
  setNewProjectInputModalOpen,
  renameModal,
  setRenameModal,
  projectName,
  setProjectName,
  handleNewProjectName,
  handleRenameProjec,
  ProjectType,
  setProjectType,
}) {
  const isCreate = Boolean(newProjectInputModalOpen);
  const isRename = Boolean(renameModal?.isOpen);
  const isOpen = isCreate || isRename;

  const isCard = isRename
    ? Boolean(renameModal?.isCard)
    : ProjectType === "card";

  const nameValue = isCreate ? projectName : renameModal?.title || "";
  const disabled = !String(nameValue || "").trim();

  const title = isCreate
    ? isCard
      ? "Create card project"
      : "Create scroll project"
    : isCard
      ? "Rename card project"
      : "Rename scroll project";

  const subtitle = isCreate
    ? "Start from scratch with a blank canvas."
    : "Update the name of this project.";

  const placeholder = isCard
    ? "e.g. Indie Short Film Cards"
    : "e.g. Indie Short Film";

  const primaryLabel = isCreate ? "Create" : "Rename";

  const handleClose = () => {
    if (isCreate) {
      setNewProjectInputModalOpen?.(false);
      setProjectType?.("scroll");
      return;
    }
    setRenameModal?.((prev) => ({
      ...prev,
      isOpen: false,
      title: "",
    }));
  };

  const handleSubmit = () => {
    if (disabled) return;
    if (isCreate) {
      handleNewProjectName?.();
      return;
    }
    handleRenameProjec?.();
  };

  const handleKeypress = (e) => {
    if (
      e.key === "Enter" &&
      (e.code === "Enter" || e.code === "NumpadEnter") &&
      !disabled
    ) {
      handleSubmit();
    }
  };

  const handleNameChange = (e) => {
    const value = e.target.value;
    if (isCreate) {
      setProjectName?.(value);
      return;
    }
    setRenameModal?.((prev) => ({
      ...prev,
      title: value,
    }));
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={handleClose}
      style={{
        overlay: {
          backgroundColor: "rgba(6, 5, 12, 0.72)",
          backdropFilter: "blur(8px)",
          zIndex: 100,
        },
        content: {
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "min(480px, calc(100vw - 32px))",
          maxHeight: "calc(100vh - 32px)",
          padding: 0,
          border: "1px solid rgba(124, 92, 255, 0.25)",
          borderRadius: "20px",
          background: "#12101c",
          overflow: "visible",
          outline: "none",
        },
      }}
      className="create-custom-project-modal"
    >
      <div className="relative p-6 md:p-7">
        <button
          type="button"
          onClick={handleClose}
          className="absolute top-5 right-5 p-2 rounded-full text-[#625e83] hover:text-white hover:bg-[rgba(255,255,255,0.06)] transition-colors"
          aria-label="Close"
        >
          <FiX className="w-4 h-4" />
        </button>

        <div className="pr-8 mb-6">
          <h2 className="font-body text-[22px] font-semibold text-white tracking-tight">
            {title}
          </h2>
          <p className="font-body text-[14px] text-[#a8a4c8] mt-1.5 leading-relaxed">
            {subtitle}
          </p>
        </div>

        <div>
          <label
            htmlFor="rename-project-name"
            className="block font-body text-[13px] text-white mb-2"
          >
            Project Name
          </label>
          <input
            id="rename-project-name"
            name="rename-project-name"
            type="text"
            autoFocus
            autoComplete="off"
            autoCorrect="off"
            autoCapitalize="off"
            spellCheck={false}
            data-lpignore="true"
            data-form-type="other"
            value={nameValue}
            placeholder={placeholder}
            onChange={handleNameChange}
            onKeyDown={handleKeypress}
            className="ccp-input font-body"
          />
        </div>

        <div className="mt-7 flex items-center gap-3">
          <button
            type="button"
            onClick={handleClose}
            className="flex-1 py-3 rounded-xl font-body text-[15px] font-semibold text-[#a8a4c8] border border-[rgba(124,92,255,0.6)] bg-[rgba(255,255,255,0.02)] hover:text-white hover:border-[#7c5cff] hover:bg-[rgba(124,92,255,0.06)] transition-all"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={handleSubmit}
            disabled={disabled}
            className="flex-1 py-3 rounded-xl font-body text-[15px] font-semibold transition-all disabled:cursor-not-allowed bg-[#7c5cff] text-white hover:bg-[#9d7dff] disabled:opacity-40 hover:enabled:-translate-y-px hover:enabled:shadow-[0_8px_24px_-8px_rgba(124,92,255,0.6)]"
          >
            {primaryLabel}
          </button>
        </div>
      </div>
    </Modal>
  );
}

export default UserInputModal;
